<template>
  <q-page>
    <q-table title="Retail Orders"
             :columns="ordersColumns"
             :data="retailOrders" flat
             :pagination.sync="pagination"
             :filter="filter"
             binary-state-sort
              row-key="orderId" >
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="orderNumber" :props="props"><router-link :to="`/admin/retail-orders/${props.row.id}`">{{(props.row||{}).orderNumber}}</router-link></q-td>
          <q-td key="user" :props="props"><router-link :to="`/admin/accounts/${props.row.account.id}`">{{props.row.account.contactName}}</router-link></q-td>
          <q-td key="datePlaced" :props="props">{{formatDate(props.row.placed)}}</q-td>
          <q-td key="totalCost" :props="props">${{Number(props.row.totalCost).toFixed(2)}}</q-td>
          <q-td key="actions" :props="props">
            <q-btn dense flat icon="edit" size="sm" :to="`/admin/retail-orders/${props.row.id}`"></q-btn>
          </q-td>
        </q-tr>
      </template>
    </q-table>
  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'

export default {
  name: 'PageAdminStockOrders',
  apollo: {
    retailOrders: {
      query: gql`query {
        retailOrders {
          id
          orderNumber
          name
          notes
          account {
            id
            contactName
          }
          placed
          verified
          paid
          packed
          shipped
          delivered
          createdAt
          updatedAt
          totalCost
        }
      }
      `,
      fetchPolicy: 'network-only'
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    formatDate (d) {
      if (!d) return '-'
      return moment(d).format('DD/MM/YY')
    }
  },
  data () {
    return {
      filter: '',
      ordersColumns: [
        { name: 'orderNumber', align: 'left', required: true, label: 'Order #', field: 'orderNumber', sortable: true },
        { name: 'user', align: 'left', required: true, label: 'Customer', field: row => row.account.contactName, sortable: true },
        { name: 'datePlaced', align: 'left', required: true, label: 'Date Submitted', field: row => row.submitted, sortable: true },
        { name: 'totalCost', align: 'left', required: true, label: 'Value', field: row => Number(row.totalCost), sortable: true },
        { name: 'actions', align: 'center', required: true, label: 'Actions', field: '', sortable: false }
      ],
      pagination: {
        rowsPerPage: 20,
        sortBy: 'datePlaced'
      }
    }
  }
}
</script>
